import { Component } from 'preact';

class NavigationArrow extends Component {
  render(props, state) {

      return (
        <span>
          {props.show && !props.open && <i className="fas fa-chevron-left"></i>}
          {props.show && props.open && <i className="fas fa-chevron-down"></i>}
        </span>
      );
	}
}

export {NavigationArrow};



// WEBPACK FOOTER //
// ./components/sidebar/navigationArrow.js